import { PgProps } from '../pgSlice'

export const getTotalPauseDuration = (state: PgProps) => {
  return Object.values(state.pauseHistory).reduce((prev, curr) => prev + curr, 0)
}
